module.exports = __webpack_public_path__ + "static/media/overpass-mono-light.326c58fb.eot";